(() => {
  function isEligibleBookDate(day, month, year, today = new Date()) {
    const birth = new Date(year, month - 1, day);
    return Number.isInteger(day) && Number.isInteger(month) && Number.isInteger(year) && year >= 1900 && birth.getFullYear() === year && birth.getMonth() === month - 1 && birth.getDate() === day && new Date(year + 16, month - 1, day) <= today;
  }
  function init() {
    const intro = document.querySelector('[data-book-intro]');
    if (!intro || intro.dataset.bookReady) return;
    intro.dataset.bookReady = 'true';
    const purchase = document.querySelector('#PersonalizeYourBook');
    const purchaseRegion = document.querySelector('[data-book-purchase]') || purchase;
    const sticky = document.querySelector('[data-book-sticky]');
    const final = document.querySelector('[data-book-final]');
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
    const track = (name, data) => {
      try {
        if (window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.() !== true) return;
        const published = window.Shopify?.analytics?.publish?.(name, data);
        if (published?.catch) published.catch(() => {});
      } catch (_) {}
    };
    document.querySelectorAll('[data-book-cta]').forEach(link => {
      link.addEventListener('click', event => {
        if (!purchase) return;
        event.preventDefault();
        track('luvire_book_cta_clicked', { placement: link.dataset.bookCta });
        if (link.dataset.bookCta === 'sticky' && purchaseRegion) {
          const rect = purchaseRegion.getBoundingClientRect();
          const detailsButton = purchaseRegion.querySelector('[data-book-order-next]');
          if (detailsButton && rect.top < window.innerHeight && rect.bottom > 0) { detailsButton.click(); return; }
        }
        purchase.scrollIntoView({ behavior: reduced.matches ? 'auto' : 'smooth', block: 'start' });
        const heading = purchase.querySelector('h2');
        heading?.focus({ preventScroll: true });
      });
    });
    document.querySelectorAll('[data-book-gallery]').forEach(gallery => {
      const rail = gallery.querySelector('[data-book-track]');
      const swipeSurface = gallery.querySelector('.luvire-book__binding') || rail;
      const slides = [...gallery.querySelectorAll('[data-book-slide]')];
      const selectors = [...gallery.querySelectorAll('[data-book-slide-to]')];
      if (!rail || !slides.length) return;
      let current = 0;
      let settleTimer;
      let turnCleanup;
      let turnView;
      let gesture;
      let suppressClickUntil = 0;
      let wheelAmount = 0;
      let wheelTurned = false;
      let wheelReset;
      rail.dataset.bookPaging = 'true';
      const stopTurn = () => turnCleanup?.();
      const warm = image => { if (image.complete && image.naturalWidth && image.decode) image.decode().catch(() => {}); };
      gallery.querySelectorAll('.luvire-book__sample img').forEach(image => {
        image.draggable = false;
        warm(image);
        image.addEventListener('load', () => warm(image));
      });
      const buildTurn = (from, to, backwards) => {
        const before = [...slides[from].querySelectorAll('.luvire-book__sample img')];
        const after = [...slides[to].querySelectorAll('.luvire-book__sample img')];
        if (reduced.matches || !window.CSS?.supports('transform-style', 'preserve-3d') || before.length !== 2 || after.length !== 2) return null;
        if (![...before, ...after].every(image => image.complete && image.naturalWidth > 0)) return null;
        if (Math.abs(rail.scrollLeft - from * rail.clientWidth) > 2) return null;
        const stage = gallery.querySelector('.luvire-book__book-stage');
        const stageRect = stage.getBoundingClientRect();
        const leftRect = before[0].getBoundingClientRect();
        const rightRect = before[1].getBoundingClientRect();
        if (!turnView) {
          const layer = document.createElement('div');
          layer.setAttribute('aria-hidden', 'true');
          const still = document.createElement('img');
          still.className = 'luvire-book__turn-still';
          const leaf = document.createElement('div');
          leaf.className = 'luvire-book__turn-leaf';
          const faces = [false, true].map(back => {
            const face = document.createElement('div');
            face.className = 'luvire-book__turn-face' + (back ? ' luvire-book__turn-face--back' : '');
            const image = document.createElement('img');
            face.append(image);
            leaf.append(face);
            return image;
          });
          [still, ...faces].forEach(image => { image.alt = ''; image.draggable = false; });
          layer.append(still, leaf);
          turnView = { layer, leaf, still, faces, stage };
        }
        const { layer, still, faces } = turnView;
        layer.className = 'luvire-book__turn-layer' + (backwards ? ' luvire-book__turn-layer--backwards' : '');
        Object.assign(layer.style, {
          left: `${leftRect.left - stageRect.left}px`, top: `${leftRect.top - stageRect.top}px`,
          width: `${rightRect.right - leftRect.left}px`, height: `${Math.max(leftRect.height, rightRect.height)}px`
        });
        layer.style.setProperty('--turn-page-width', `${leftRect.width}px`);
        [before[backwards ? 1 : 0], before[backwards ? 0 : 1], after[backwards ? 1 : 0]].forEach((original, index) => {
          const image = [still, ...faces][index];
          image.src = original.currentSrc || original.src;
          image.width = original.naturalWidth;
          image.height = original.naturalHeight;
          image.style.objectPosition = getComputedStyle(original).objectPosition;
        });
        return turnView;
      };
      const update = index => {
        current = index;
        selectors.forEach(button => button.setAttribute('aria-pressed', String(Number(button.dataset.bookSlideTo) === current)));
        gallery.querySelector('[data-book-gallery-status]').textContent = gallery.dataset.bookStatusTemplate.replace('__current__', current + 1);
      };
      const goTo = index => {
        const next = (index + slides.length) % slides.length;
        stopTurn();
        if (next === current) return;
        const turn = buildTurn(current, next, index < current);
        clearTimeout(settleTimer);
        update(next);
        rail.scrollTo({ left: current * rail.clientWidth, behavior: turn || reduced.matches ? 'auto' : 'smooth' });
        if (!turn) return;
        let cleanupTimer;
        const cleanup = () => {
          clearTimeout(cleanupTimer);
          turn.leaf.removeEventListener('animationend', finish);
          turn.layer.remove();
          if (turnCleanup === cleanup) turnCleanup = null;
        };
        const finish = event => { if (event.target === turn.leaf) cleanup(); };
        turnCleanup = cleanup;
        turn.leaf.addEventListener('animationend', finish);
        cleanupTimer = setTimeout(cleanup, 800);
        turn.stage.append(turn.layer);
      };
      gallery.querySelector('[data-book-previous]').addEventListener('click', () => goTo(current - 1));
      gallery.querySelector('[data-book-next]').addEventListener('click', () => goTo(current + 1));
      selectors.forEach(button => button.addEventListener('click', () => goTo(Number(button.dataset.bookSlideTo))));
      rail.addEventListener('scroll', () => {
        clearTimeout(settleTimer);
        if (turnCleanup) return;
        settleTimer = setTimeout(() => update(Math.min(slides.length - 1, Math.max(0, Math.round(rail.scrollLeft / rail.clientWidth)))), 100);
      }, { passive: true });
      swipeSurface.addEventListener('wheel', event => {
        if (event.ctrlKey) return;
        const dx = event.shiftKey && !event.deltaX ? event.deltaY : event.deltaX;
        const dy = event.shiftKey ? 0 : event.deltaY;
        if (!dx || Math.abs(dx) <= Math.abs(dy) * 1.2) return;
        if (event.cancelable) event.preventDefault();
        clearTimeout(wheelReset);
        wheelReset = setTimeout(() => { wheelAmount = 0; wheelTurned = false; }, 220);
        if (wheelTurned) return;
        const unit = event.deltaMode === 1 ? 16 : event.deltaMode === 2 ? rail.clientWidth : 1;
        wheelAmount += dx * unit;
        if (Math.abs(wheelAmount) < 32) return;
        wheelTurned = true;
        goTo(current + (wheelAmount > 0 ? 1 : -1));
      }, { passive: false });
      const startGesture = (x, y, id) => {
        stopTurn();
        gesture = { x, y, id, horizontal: false };
      };
      const moveGesture = (x, y, event) => {
        if (!gesture) return;
        const dx = Math.abs(x - gesture.x);
        const dy = Math.abs(y - gesture.y);
        if (!gesture.horizontal) {
          if (dy > 12 && dy > dx) { gesture = null; return; }
          if (dx < 8 || dx < dy * 1.2) return;
          gesture.horizontal = true;
          swipeSurface.classList.add('is-dragging');
        }
        suppressClickUntil = performance.now() + 400;
        if (event.cancelable) event.preventDefault();
      };
      const finishGesture = (x, y) => {
        const completed = gesture;
        gesture = null;
        swipeSurface.classList.remove('is-dragging');
        if (!completed) return;
        const dx = x - completed.x;
        const dy = y - completed.y;
        const threshold = Math.min(40, Math.max(20, swipeSurface.clientWidth * .06));
        if (Math.abs(dx) < threshold || Math.abs(dx) < Math.abs(dy) * 1.2) return;
        suppressClickUntil = performance.now() + 400;
        goTo(current + (dx < 0 ? 1 : -1));
      };
      const cancelGesture = () => {
        gesture = null;
        swipeSurface.classList.remove('is-dragging');
      };
      const isControl = target => target.closest('[data-book-previous], [data-book-next]');
      swipeSurface.addEventListener('dragstart', event => event.preventDefault());
      swipeSurface.addEventListener('pointerdown', event => {
        if (event.pointerType === 'touch' || !event.isPrimary || event.button !== 0 || isControl(event.target)) return;
        startGesture(event.clientX, event.clientY, event.pointerId);
        swipeSurface.setPointerCapture(event.pointerId);
        event.preventDefault();
      });
      window.addEventListener('pointermove', event => {
        if (!gesture || gesture.id !== event.pointerId || event.pointerType === 'touch') return;
        moveGesture(event.clientX, event.clientY, event);
      }, { passive: false });
      window.addEventListener('pointerup', event => {
        if (!gesture || gesture.id !== event.pointerId || event.pointerType === 'touch') return;
        finishGesture(event.clientX, event.clientY);
        if (swipeSurface.hasPointerCapture(event.pointerId)) swipeSurface.releasePointerCapture(event.pointerId);
      });
      window.addEventListener('pointercancel', event => {
        if (gesture?.id === event.pointerId && event.pointerType !== 'touch') cancelGesture();
      });
      swipeSurface.addEventListener('touchstart', event => {
        if (event.touches.length !== 1 || isControl(event.target)) { cancelGesture(); return; }
        const touch = event.touches[0];
        startGesture(touch.clientX, touch.clientY, 'touch');
      }, { passive: true });
      swipeSurface.addEventListener('touchmove', event => {
        if (gesture?.id !== 'touch') return;
        if (event.touches.length !== 1) { cancelGesture(); return; }
        const touch = event.touches[0];
        moveGesture(touch.clientX, touch.clientY, event);
      }, { passive: false });
      swipeSurface.addEventListener('touchend', event => {
        if (gesture?.id !== 'touch') return;
        const touch = event.changedTouches[0];
        finishGesture(touch.clientX, touch.clientY);
      }, { passive: true });
      swipeSurface.addEventListener('touchcancel', cancelGesture, { passive: true });
      window.addEventListener('blur', cancelGesture);
      swipeSurface.addEventListener('click', event => {
        if (performance.now() < suppressClickUntil) { event.preventDefault(); event.stopImmediatePropagation(); }
      }, true);
      reduced.addEventListener('change', () => { if (reduced.matches) stopTurn(); });
      document.addEventListener('visibilitychange', () => { if (document.hidden) stopTurn(); });
      gallery.addEventListener('keydown', event => {
        if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        const target = event.key === 'Home' ? 0 : event.key === 'End' ? slides.length - 1 : current + (event.key === 'ArrowLeft' ? -1 : 1);
        goTo(target);
      });
      if ('ResizeObserver' in window) {
        let previousWidth = rail.clientWidth;
        new ResizeObserver(() => {
          if (rail.clientWidth === previousWidth) return;
          previousWidth = rail.clientWidth;
          stopTurn();
          clearTimeout(settleTimer);
          rail.scrollTo({ left: current * rail.clientWidth, behavior: 'auto' });
        }).observe(rail);
      }
    });
    const orderForm = document.querySelector('[data-book-order-flow]');
    if (orderForm) {
      const dialog = orderForm.querySelector('[data-book-details-dialog]');
      const personalFields = orderForm.querySelector('[data-book-personal-fields]');
      ['builder', 'partner'].forEach(prefix => {
        const day = orderForm.querySelector(`[data-lab-${prefix}-day]`);
        const month = orderForm.querySelector(`[data-lab-${prefix}-month]`);
        const year = orderForm.querySelector(`[data-lab-${prefix}-year]`);
        if (!day || !month || !year) return;
        const updateDates = () => {
          const today = new Date();
          const latestYear = today.getFullYear() - 16;
          [...year.options].forEach(option => {
            if (option.value && Number(option.value) > latestYear) option.remove();
          });
          const firstYear = Number(year.options[1]?.value || 1899);
          for (let value = firstYear + 1; value <= latestYear; value++) {
            const option = document.createElement('option');
            option.value = String(value);
            option.textContent = String(value);
            year.insertBefore(option, year.options[1] || null);
          }
          const selectedYear = Number(year.value);
          const latest = selectedYear === latestYear;
          [...month.options].forEach(option => {
            option.disabled = !!option.value && latest && Number(option.value) > today.getMonth() + 1;
          });
          if (month.selectedOptions[0]?.disabled) month.value = '';
          const selectedMonth = Number(month.value);
          const lastDay = selectedMonth ? new Date(selectedYear || 2000, selectedMonth, 0).getDate() : 31;
          const cutoffDay = latest && selectedMonth === today.getMonth() + 1 ? today.getDate() : lastDay;
          [...day.options].forEach(option => {
            option.disabled = !!option.value && Number(option.value) > Math.min(lastDay, cutoffDay);
          });
          if (day.selectedOptions[0]?.disabled) day.value = '';
          day.setCustomValidity('');
        };
        [day, month, year].forEach(field => field.addEventListener('change', updateDates));
        updateDates();
      });
      const next = orderForm.querySelector('[data-book-order-next]');
      const partner = orderForm.querySelector('[data-lab-addon][data-handle="partner-compatibility"]');
      const partnerFields = orderForm.querySelector('[data-lab-partner-fields]');
      const back = orderForm.querySelector('[data-book-personal-back]');
      const heading = orderForm.querySelector('[data-book-dialog-title]');
      const buyLabel = orderForm.querySelector('[data-lab-buy] span');
      const checkoutLabel = buyLabel.textContent;
      let partnerStep = false;
      let dialogWidth = window.innerWidth;
      let pagePosition;
      let bodyPosition;
      const lockPage = () => {
        pagePosition = window.scrollY;
        bodyPosition = { position: document.body.style.position, top: document.body.style.top, width: document.body.style.width };
        document.body.style.position = 'fixed';
        document.body.style.top = `-${pagePosition}px`;
        document.body.style.width = '100%';
      };
      const unlockPage = () => {
        Object.assign(document.body.style, bodyPosition);
        window.scrollTo({ top: pagePosition, behavior: 'instant' });
      };
      const syncDialog = () => {
        const selected = !!partner?.checked;
        if (!selected) partnerStep = false;
        partnerFields.hidden = !selected || !partnerStep;
        personalFields.hidden = partnerStep;
        back.hidden = !partnerStep;
        partnerFields.querySelectorAll('select').forEach(field => { field.required = selected; });
        heading.textContent = partnerStep ? dialog.dataset.partnerTitle : dialog.dataset.ownTitle;
        buyLabel.textContent = selected && !partnerStep ? dialog.dataset.partnerContinue : checkoutLabel;
        orderForm.querySelector('[data-book-modal-total]').textContent = orderForm.querySelector('[data-lab-total]').textContent;
        const regular = orderForm.querySelector('[data-lab-total-regular]');
        const modalRegular = orderForm.querySelector('[data-book-modal-regular]');
        modalRegular.hidden = regular.hidden;
        modalRegular.textContent = regular.textContent;
      };
      const sizeDialog = () => {
        const height = document.documentElement.clientHeight || window.innerHeight;
        dialog.dataset.bookRoomy = String(window.innerWidth >= 375 && height >= 650);
        dialog.style.setProperty('--book-dialog-height', `${Math.max(120, height - 24)}px`);
        dialog.style.setProperty('--book-dialog-top', `${height / 2}px`);
        dialogWidth = window.innerWidth;
      };
      const openDialog = () => {
        partnerStep = false;
        syncDialog();
        orderForm.dataset.bookOrderStage = 'details';
        sizeDialog();
        lockPage();
        dialog.showModal();
        heading.focus({ preventScroll: true });
      };
      const validatePersonal = () => {
        const fields = [...personalFields.querySelectorAll('input, select')];
        for (const field of fields) if (!field.reportValidity()) return false;
        const day = personalFields.querySelector('[data-lab-builder-day]');
        const month = personalFields.querySelector('[data-lab-builder-month]');
        const year = personalFields.querySelector('[data-lab-builder-year]');
        const valid = isEligibleBookDate(Number(day.value), Number(month.value), Number(year.value));
        if (!valid) {
          day.setCustomValidity(dialog.dataset.invalidDate);
          day.reportValidity();
        }
        return valid;
      };
      next.addEventListener('click', openDialog);
      orderForm.querySelector('[data-book-dialog-close]').addEventListener('click', () => dialog.close());
      back.addEventListener('click', () => {
        partnerStep = false;
        syncDialog();
        heading.focus({ preventScroll: true });
      });
      dialog.addEventListener('click', event => {
        if (event.target !== dialog) return;
        const rect = dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
      });
      dialog.addEventListener('close', () => {
        unlockPage();
        orderForm.dataset.bookOrderStage = 'chapters';
        next.focus({ preventScroll: true });
      });
      orderForm.addEventListener('change', () => {
        personalFields.querySelector('[data-lab-builder-day]').setCustomValidity('');
        syncDialog();
      });
      orderForm.querySelector('[data-lab-bundle-toggle]')?.addEventListener('click', syncDialog);
      window.addEventListener('resize', () => {
        if (dialog.open && Math.abs(window.innerWidth - dialogWidth) > 2) sizeDialog();
      }, { passive: true });
      orderForm.addEventListener('submit', event => {
        if (dialog.open && (!partner?.checked || partnerStep)) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        if (!dialog.open) { openDialog(); return; }
        if (!validatePersonal()) return;
        partnerStep = true;
        syncDialog();
        heading.focus({ preventScroll: true });
      }, true);
      syncDialog();
    }
    document.querySelectorAll('[data-lab-addon]').forEach(input => {
      input.addEventListener('change', () => track('luvire_book_chapter_selected', {
        chapter: input.dataset.handle,
        selected: input.checked,
        selected_count: document.querySelectorAll('[data-lab-addon]:checked').length
      }));
    });
    document.querySelector('[data-lab-builder-form]')?.addEventListener('submit', () => {
      track('luvire_book_checkout_clicked', { selected_count: document.querySelectorAll('[data-lab-addon]:checked').length });
    });
    if (sticky && purchase && final && 'IntersectionObserver' in window) {
      const targets = [intro.querySelector('[data-book-cta="hero"]'), orderForm?.querySelector('[data-book-order-next]'), final.querySelector('[data-book-cta="final"]'), document.querySelector('footer.footer')].filter(Boolean);
      const stickyPrice = sticky.querySelector('strong');
      const startingPrice = stickyPrice.textContent;
      let previewBar;
      const previewObserver = 'ResizeObserver' in window ? new ResizeObserver(entries => {
        sticky.style.setProperty('--book-preview-offset', `${entries[0].target.getBoundingClientRect().height}px`);
      }) : null;
      const update = () => {
        const inputFocused = /^(INPUT|SELECT|TEXTAREA)$/.test(document.activeElement?.tagName || '');
        const inView = element => {
          const rect = element.getBoundingClientRect();
          return rect.height > 0 && rect.bottom > 0 && rect.top < window.innerHeight;
        };
        sticky.hidden = inputFocused || !!orderForm?.querySelector('[data-book-details-dialog]')?.open || targets.some(inView);
        const rect = purchaseRegion?.getBoundingClientRect();
        stickyPrice.textContent = rect && rect.bottom > 0 && rect.top < window.innerHeight ? orderForm?.querySelector('[data-lab-total]')?.textContent || startingPrice : startingPrice;
        const currentPreview = document.getElementById('PBarNextFrameWrapper');
        if (currentPreview && currentPreview !== previewBar) {
          previewBar = currentPreview;
          sticky.style.setProperty('--book-preview-offset', `${previewBar.getBoundingClientRect().height}px`);
          previewObserver?.observe(previewBar);
        }
      };
      const observer = new IntersectionObserver(update);
      targets.forEach(element => observer.observe(element));
      observer.observe(purchaseRegion);
      document.addEventListener('focusin', update);
      document.addEventListener('focusout', () => requestAnimationFrame(update));
      orderForm?.addEventListener('change', update);
      orderForm?.querySelector('[data-lab-bundle-toggle]')?.addEventListener('click', update);
      orderForm?.querySelector('[data-book-details-dialog]')?.addEventListener('close', update);
      window.addEventListener('resize', update, { passive: true });
      update();
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
  document.addEventListener('shopify:section:load', init);
})();
